import RegisterPage from "@/features/auth/pages/register";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/__auth/register")({
  component: RegisterRoute,
});

function RegisterRoute() {
  return <RegisterPage />;
}
